export enum LegacyReferralMessageTypeEnum {
  NewReferral = 1,
  Assignment = 2,
  Unassignment = 3,
  ClinicianAccepted = 4,
  ReferralCancelled = 5,
  DisciplineRemoved = 6
}

export const LegacyReferralMessageTypeOptions = [
{ id: 1, label: 'New Referral' },
{ id: 2, label: 'Assignment' },
{ id: 3, label: 'Unassignment' },
{ id: 4, label: 'Clinician Accepted' },
{ id: 5, label: 'Referral Cancelled' },
{ id: 6, label: 'Discipline Removed' }
];
